<div class="header_container">
  <div class="header">
    <div class="logo">
      <img src="assets/zabkagroup_logo.webp" alt="logo">
    </div>

    <app-user-panel></app-user-panel>
  </div>
</div>
